export const HAS_LOWERCASE = /[a-z]/;
export const HAS_NUMBER = /[0-9]/;
export const HAS_UPPERCASE = /[A-Z]/;
export const IS_INPUT_DATE = /^\d{4}\/\d{2}\/\d{2}$/;
export const IS_SURVEY_DATE = /^\d{4}-\d{2}-\d{2}$/;
export const IS_VALID_PHONE = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
